import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const jsonHeaders = () => {
	return {
		...authHeader(),
		'Content-Type': 'application/json',
	};
};

/**
 * Record a payment against a bill. `data.billId` is the bill's clientTransactionId,
 * not its row id — the same key the 3rd-party integration posts with.
 * data: { billId, paymentMode, paymentAmount, referenceNumber, paymentDate, notes }
 */
function createBillPayment(req) {
	const requestOptions = {
		method: 'POST',
		headers: jsonHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.CREATE_BILL_PAYMENT, requestOptions).then(
		handleResponse
	);
}

/**
 * Payments for one bill (`billId`), for a page of bills (`billIds` — row ids), or a
 * window filtered by storeIds / vendorId / paymentMode / dateRange.
 * Returns { payments: [...], billWisePayments: { [billRowId]: {...} } }.
 */
function fetchBillPayments(req) {
	const requestOptions = {
		method: 'POST',
		headers: jsonHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.FETCH_BILL_PAYMENTS, requestOptions).then(
		handleResponse
	);
}

/** Bill header + its payment history + the allowed payment modes. */
function fetchBillPaymentDetail(req) {
	const requestOptions = {
		method: 'POST',
		headers: jsonHeaders(),
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.FETCH_BILL_PAYMENT_DETAIL, requestOptions).then(
		handleResponse
	);
}

/** The paymentMode vocabulary, so the dropdown never drifts from the validator. */
function fetchBillPaymentModes() {
	const requestOptions = {
		method: 'GET',
		headers: jsonHeaders(),
	};
	return fetch(endpoints.FETCH_BILL_PAYMENT_MODES, requestOptions).then(
		handleResponse
	);
}

const billPaymentsServices = {
	createBillPayment,
	fetchBillPayments,
	fetchBillPaymentDetail,
	fetchBillPaymentModes,
};

export default billPaymentsServices;
